/** Etiquetas alineadas con backend/modules/informes-iva/informeIvaFrequency.js */

export const FRECUENCIA_GLOBAL_OPTIONS = [
  { value: 'DIAS_5', label: 'Cada 5 días' },
  { value: 'DIAS_7', label: 'Cada 7 días' },
  { value: 'DIAS_15', label: 'Cada 15 días' },
  { value: 'SEMANAL', label: 'Semanal (7 días)' },
  { value: 'QUINCENAL', label: 'Quincenal (15 días)' },
  { value: 'MENSUAL', label: 'Mensual (30 días)' }
];

export const FRECUENCIA_CLIENTE_OPTIONS = [
  { value: 'GLOBAL', label: 'Usar frecuencia global (Administración)' },
  { value: 'MANUAL', label: 'Solo manual — nunca automático' },
  ...FRECUENCIA_GLOBAL_OPTIONS
];

export function labelFrecuencia(value) {
  return FRECUENCIA_CLIENTE_OPTIONS.find((o) => o.value === value)?.label || value || '—';
}
